<div class="wrapper"
	(click)="getLabel(selectedOptions[0])"
	[ngClass]="'theme-' + theme"
	[class.is-open]="isOpen"
	[class.in-mat-form-field]="inMatFormField"
	[class.theme-alternate]="theme === 'dark'"
	>
	<div class="display-value" [class.with-value-selected]="modelValue" data-cy="entity-click" (click)="onDisplayValueClick($event)" *ngIf="!multi && !inlineSearch" 
	[style.opacity]="hideValue ? 0 : 1" [style.pointer-events]="hideValue ? 'none' : 'initial'">
		<div class="display-value-inner" [class.placeholder-wrapper]="!modelValue">
			<span *ngIf="selectedOptions.length && !facet && entityType && modelValue">
				<ng-container *ngTemplateOutlet="entityDisplay; context: {entity: selectedOptions[0], settings: {hideIcon: true, hideThumbnail: true}}"></ng-container>
			</span>
			<span *ngIf="(!selectedOptions.length && modelValue) || !modelValue">
				<span>
					{{ modelValue ? modelValue[0] : placeholderText }}
				</span>
			</span>
			<span *ngIf="selectedOptions.length && (!entityType || entityType && facet)" class="option-display">
				<ng-container *ngTemplateOutlet="optionDisplay; context: {option: selectedOptions[0], settings: {hideIcon: hideIcons}}"></ng-container>
			</span>
		</div>

		<div
			class="clear-selected-option center-content"
			[hidden]="modelValue === null || ( modelValue && modelValue.length && !modelValue[0]) || disableClear"
			(click)="clearSelectedOption($event)"
		>
			<i class="fas fa-xmark"></i>
		</div>
		<div class="center-content dropdown-button">
			<i class="fa fa-{{ icon }}"></i>
		</div>

	</div>
	<div class="display-value-multi bb-block-input" (click)="onDisplayValueClick($event)" *ngIf="multi">
		<span *ngIf="placeholderText && (!selectedOptions.length && modelValue) || !modelValue" class="placeholder-text">
			<span>
				{{ modelValue ? modelValue[0] : placeholderText }}
			</span>
		</span>
		<div class="center-content dropdown-button">
			<i class="fa fa-{{ icon }}"></i>
		</div>
		<div class="option-wrapper" (ngInit)="isPartial = {}">
			<div *ngFor="let option of selectedOptions; let i = index;" class="option-box" (contextmenu)="onEntityContextMenu( (entityType && !facet ? $event : null), option)">
				<div *ngIf="option" class="pill" (ngInit)="isPartial[option[valueProp]] = partials?.length && partials.indexOf(option[valueProp]) !== -1" [class.partial]="isPartial[option[valueProp]]">
					<span class="value" (click)="onValueClicked($event, isPartial[option[valueProp]], option)" [title]="isPartial[option[valueProp]] ? partialText : ''">
						<span class="prop status-icon" [hidden]="!option?.status" [innerHTML]="option | statusIcon"></span>
						{{ option && (option[labelProp] || option?.label || option?.title || option?.originalfilename || option[valueProp] || option?.id || modelValue[i]) }}
					</span>
					<span class="remove-option" (click)="removeOptionClicked(option, i, $event)">
						<i class="fa fa-times"></i>
					</span>
				</div>
			</div>
		</div>
	</div>
	<div class="dropdown-panel" [hidden]="!isOpen">
		<div class="search-wrapper">
			<input
				#inputAutoComplete
				type="text"
				[placeholder]=""
				matInput
				class="prop-value value-text white-bordered"
				(focus)="onInputFocus($event)"
				(keydown.escape)="close()"
				[matAutocomplete]="auto"
				[hidden]="!isOpen"
				[value]="searchValue"
				[matAutocompletePosition]="panelPosition"
				(paste)="onPaste($event)" 
				[attr.data-cy]="'entity-selector-' + valueProp"
			/>
		</div>
		<div class="dropdown-results">
			<div class="no-results" [hidden]="filteredOptions.length > 0 || ( !searched && !options?.length )">
				{{ 'NO_RESULTS_FOUND' | translate }}
			</div>
		
			<mat-autocomplete
				(mouseup)="$event.stopPropagation()"
				isOpen
				autoActiveFirstOption 
				#auto="matAutocomplete"
				panelClass="dropdown-panel"
				(opened)="onMatAutocompleteOpened.bind(this)"
				(closed)="onMatAutocompleteClosed.bind(this)"
				[displayWith]="displayFn.bind(this)"
				(optionSelected)="onMatOptionSelected($event)"
				[class]="this.autocompleteClass"
			>
				<mat-option
					(mouseup)="$event.stopPropagation()"
					*ngIf="(!entityType || (searched && !searching)) && extendable && inputAutoComplete.value && !labelInOptions(inputAutoComplete.value) && !labelInSelectedOptions(inputAutoComplete.value)"
					[value]="inputAutoComplete.value"
				>
					<div class="extendable">
						{{ 'ADD_NEW_VALUE' | translate }}: {{ inputAutoComplete.value }}
					</div>
				</mat-option>
				
				<mat-option disabled 
					*ngIf="(!entityType || (searched && !searching)) && extendable && inputAutoComplete.value && labelInSelectedOptions(inputAutoComplete.value)">
					<div class="no-results">
						{{ 'VALUE_ALREADY_SELECTED' | translate }}
					</div>
				</mat-option>
				
				<mat-option disabled *ngIf="searching">
					<div class="searching">
						{{ 'SEARCHING' | translate }}...
					</div>
				</mat-option>

				<mat-option 
					*ngFor="let option of filteredOptions"
					[value]="option[valueProp] || option.value"
					(mouseup)="$event.stopPropagation()"
					
					>
					<ng-container *ngIf="entityType && !facet">
						<ng-container *ngTemplateOutlet="entityDisplay; context: {entity:option, settings: {hideThumbnail: hideThumbnail, hideIcon: hideIcons}}"></ng-container>
					</ng-container>

					<span *ngIf="options?.length || facet" class="option-display">
						<ng-container *ngTemplateOutlet="optionDisplay; context: {option: option, settings: {hideIcon: hideIcons, fromOption: true, hideThumbnail: hideThumbnail}}"></ng-container>
					</span>

				</mat-option>
				
				<mat-option disabled *ngIf="filteredOptions.length === 0 && searched && !searching && !options?.length">
					<div class="no-results">
						{{ 'NO_RESULTS_FOUND' | translate }}
					</div>
				</mat-option>

			</mat-autocomplete>
		</div>
	</div>

</div>

<ng-template #optionDisplay let-option="option" let-settings="settings">
	<span *ngIf="option.icon && (!settings || !settings.hideIcon)" class="option-icon">
		<i class="fa" [ngClass]="'fa-' + option.icon"></i>
	</span>

	<span *ngIf="option.prefixHtml" class="option-prefix-html" [innerHTML]="option.prefixHtml"></span>
	{{ getLabel(option) }}
	<span *ngIf="option?.aliases?.length" class="option-aliases">
		<ng-container *ngFor="let alias of option?.aliases">
			<ng-container *ngIf="aliasVisible(alias)">
				[ {{ alias }} ]
			</ng-container>
		</ng-container>
	</span>
</ng-template>

<ng-template #entityDisplay let-entity="entity" let-settings="settings">
	<div
		*ngIf="entity"
		class="entity-template"
		(contextmenu)="onEntityContextMenu( (!settings || settings?.fromOption ? null : $event), entity)" 
		[ngClass]="'theme-' + theme"
	>
		<span class="img-wrapper" *ngIf="(entity.mediatype === 'video' || entity.mediatype === 'audio' || entity.mediatype === 'image') && ((entity.type | lowercase) === 'mediaclip' || (entity.type | lowercase) === 'project') && !settings?.hideThumbnail">
			<span [innerHTML]="entity | thumbnail:50:30 | async" class="entity-img"></span>
		</span>
		<span class="prop" [hidden]="!(entity.mediatype || entity.type === 'MediaClipList') || settings?.hideIcon" [innerHTML]="entity | clipIcon"></span>
		<span class="prop status-icon" [hidden]="!entity.status || settings?.hideStatus" [innerHTML]="entity | statusIcon"></span>
		<span *ngIf="!['mediaclip', 'commonclip', 'creative'].includes(entityType)" class="title prop" [hidden]="settings?.hideTitle">
			<strong *ngIf="entity?.type === 'LineItem' && entity?.subtype">{{ entity?.subtype | uppercase | translate }}: </strong>
			{{ getLabel(entity) }}
		</span>
		<span *ngIf="['mediaclip', 'commonclip', 'creative'].includes(entityType) && entity?.mediatype !== 'font'" [innerHTML]="entity | clipTitle" class="title prop" [hidden]="settings?.hideTitle"></span>
		<span *ngIf="entity?.mediatype === 'font'" class="title prop font-piped" [bbFont]="entity" [hidden]="settings?.hideTitle">
			{{ entity.originalfilename }}
		</span>
		<span class="id prop" [hidden]="settings?.hideId">{{ getIdLabel(entity) }}</span>
	</div>
</ng-template>

<bb-context-menu
	[ngStyle]="contextMenuStyle"
	[themeName]="theme + '-theme'"
	[options]="contextMenuOptions"
	(optionSelected)="contextMenuStyle.display = 'none'"
	(clickOutside)="contextMenuStyle.display = 'none'"
></bb-context-menu>
